import { api } from './api'

function queryOf({ q, topics, nested } = {}) {
  const params = new URLSearchParams()
  if (q) params.set('q', q)
  if (topics?.length) params.set('topics', topics.join(','))
  if (nested) params.set('nested', '1')
  const text = params.toString()
  return text ? `?${text}` : ''
}

export function listChatrooms(filters) {
  return api.get(`/chatrooms${queryOf(filters)}`).then((data) => data.rooms)
}

export function createChatroom(body) {
  return api.post('/chatrooms', body).then((data) => data.room)
}

export function getChatroom(id) {
  return api.get(`/chatrooms/${id}`)
}

export function updateChatroom(id, body) {
  return api.patch(`/chatrooms/${id}`, body).then((data) => data.room)
}

export function deleteChatroom(id) {
  return api.del(`/chatrooms/${id}`)
}

export function addChatMember(id, userId) {
  return api.post(`/chatrooms/${id}/members`, { userId }).then((data) => data.room)
}

export function removeChatMember(id, userId) {
  return api.del(`/chatrooms/${id}/members/${userId}`).then((data) => data.room)
}

export function addChatManager(id, userId) {
  return api.post(`/chatrooms/${id}/managers`, { userId }).then((data) => data.room)
}

export function removeChatManager(id, userId) {
  return api.del(`/chatrooms/${id}/managers/${userId}`).then((data) => data.room)
}

export function muteChatroom(id) {
  return api.post(`/chatrooms/${id}/mute`, {}).then((data) => data.room)
}

export function unmuteChatroom(id) {
  return api.post(`/chatrooms/${id}/unmute`, {}).then((data) => data.room)
}

export function leaveChatroom(id) {
  return api.post(`/chatrooms/${id}/leave`, {})
}

export function sendChatMessage(id, body) {
  return api.post(`/chatrooms/${id}/messages`, body)
}

export function editChatMessage(id, messageId, body) {
  return api.patch(`/chatrooms/${id}/messages/${messageId}`, body).then((data) => data.message)
}

export function deleteChatMessage(id, messageId) {
  return api.del(`/chatrooms/${id}/messages/${messageId}`)
}

export function listChatReplies(id, messageId) {
  return api.get(`/chatrooms/${id}/messages/${messageId}/replies`).then((data) => data.replies)
}

export function sendChatReply(id, messageId, text) {
  return api.post(`/chatrooms/${id}/messages/${messageId}/replies`, { text }).then((data) => data.reply)
}

export function likeChatMessage(id, messageId) {
  return api.post(`/chatrooms/${id}/messages/${messageId}/like`, {})
}

export function unlikeChatMessage(id, messageId) {
  return api.post(`/chatrooms/${id}/messages/${messageId}/unlike`, {})
}

export function listChatLikes(id, messageId) {
  return api.get(`/chatrooms/${id}/messages/${messageId}/likes`).then((data) => data.likes)
}
